import Cookies from 'js-cookie'

function setupSidebar() {
  const sidebar = document.querySelector('.sidebar')
  const sidebarToggle = document.querySelector('.js-toggle-sidebar')

  if (!sidebarToggle) {
    return
  }

  // Suppress automatically displaying the sidebar as open on mobile.
  if (window.outerWidth < 1100 && sidebar.classList.contains('sidebar--open')) {
    sidebar.classList.remove('sidebar--open')
    sidebarToggle.innerHTML = 'Show navigation'
    sidebarToggle.setAttribute('title', 'Show navigation')
  }

  sidebarToggle.addEventListener('click', function (e) {
    e.preventDefault()

    const sidebarOpen = sidebar.classList.contains('sidebar--open')

    if (sidebarOpen) {
      sidebar.classList.remove('sidebar--open')
      sidebarToggle.innerHTML = 'Show navigation'
      sidebarToggle.setAttribute('title', 'Show navigation')
    } else {
      sidebar.classList.add('sidebar--open')
      sidebarToggle.innerHTML = 'Hide navigation'
      sidebarToggle.setAttribute('title', 'Hide navigation')
    }

    if (window.outerWidth < 1100) {
      return
    }

    if (sidebarOpen) {
      Cookies.set('sidebar_closed', true, { expires: 3650 })
    } else {
      Cookies.set('sidebar_closed', false, { expires: 3650 })
    }

    document.dispatchEvent(
      new CustomEvent('sidebar:toggle', {
        detail: sidebar.classList.contains('sidebar--open'),
      })
    )
  })
}

document.addEventListener('turbolinks:load', setupSidebar)

document.addEventListener('turbolinks:before-render', event => {
  const cachedSidebar = event.data.newBody.querySelector('.sidebar')
  if (!cachedSidebar) return

  const cachedSidebarToggle =
    event.data.newBody.querySelector('.js-toggle-sidebar')
  if (!cachedSidebarToggle) return

  const sidebarOpen = Cookies.get('sidebar_closed') === 'false'

  if (sidebarOpen) {
    cachedSidebar.classList.add('sidebar--open')
    cachedSidebarToggle.innerHTML = 'Hide navigation'
    cachedSidebarToggle.setAttribute('title', 'Hide navigation')
  } else {
    cachedSidebar.classList.remove('sidebar--open')
    cachedSidebarToggle.innerHTML = 'Show navigation'
    cachedSidebarToggle.setAttribute('title', 'Show navigation')
  }
})
